// extracted by mini-css-extract-plugin
module.exports = {"itemCard":"style_itemCard__1F4Hx","buttonFastPurchase":"style_buttonFastPurchase__REPRk","image":"style_image__AQWId","title":"style_title__tft8O","badge":"style_badge__1vpfr"};